angular
  .module('workflow')

  .factory('WorkflowDuplicateContributorsLastRating', [
    'Crud',

    function(Crud) {
      'use strict';

      class WorkflowDuplicateContributorsLastRating extends Crud {
        constructor(id) {
          super(null, '@@apiUrl' + '/update-contributors-ratings' + `/${id}`, {
            id: '@id'
          });
        }
      }
      return WorkflowDuplicateContributorsLastRating;
    }
  ]);
